import { get } from 'lodash-es';
export function shouldSizeEmbedlyContainer(state) {
    var isWeb = get(state, 'project.config.isWeb');
    return state.project.isEmbedded && !isWeb;
}
